export default "__VITE_ASSET__9fe001fe__"